"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToStartEndMonth = void 0;
const startOfMonth_1 = __importDefault(require("date-fns/startOfMonth"));
const startOfWeek_1 = __importDefault(require("date-fns/startOfWeek"));
const endOfMonth_1 = __importDefault(require("date-fns/endOfMonth"));
const endOfWeek_1 = __importDefault(require("date-fns/endOfWeek"));
const format_1 = __importDefault(require("date-fns/format"));
const standardDateFormat_1 = require("./standardDateFormat");
exports.dateToStartEndMonth = (date, validStartOfWeek) => {
    const leftDt = startOfWeek_1.default(startOfMonth_1.default(date.toDate()), {
        weekStartsOn: validStartOfWeek
    });
    const rightDt = endOfWeek_1.default(endOfMonth_1.default(date.toDate()), {
        weekStartsOn: validStartOfWeek
    });
    return {
        startDate: format_1.default(leftDt, standardDateFormat_1.dateFnsStandardDateFormat),
        endDate: format_1.default(rightDt, standardDateFormat_1.dateFnsStandardDateFormat)
    };
};
//# sourceMappingURL=dateToStartEndStrings.js.map